import QRCode from "qrcode.react"
import React from "react"

const QRCodeGenerator = ({ value = "", size = 128 }) => {
  return <QRCode size={size} value={value} />
}

// QRCodeGenerator.propTypes = {
//   value: PropTypes.string,
//   size: PropTypes.number,
// }

export default QRCodeGenerator
